import Modal from "../../../modal/Modal";
import Button from "../ButtonComponent";

import CheckSvgComponent from "../CheckSvgComponent";
// import { BUTTON_VARIANTS } from "../constant";

import styles from "./styles.module.scss";

const EnrollmentSuccessfulComponent = (props) => {
  const { assessmentType , enrollmentSuccessfull , handleClick , isPending , preAssessment } = props;
  return (
    <>
      <Modal visible={enrollmentSuccessfull}>
        <div className={styles["assessment-wrapper"]}>
          <CheckSvgComponent />
          <div className={styles.title}>Enrollment Successful</div>
          <div className={styles.description}>
            You have successfully enrolled in this course.
          </div>
          <div className={styles.note}>
            To start the course, please complete the
            <span className={styles["highlight-note"]}>
              {assessmentType || "Pre-Assessment first"}.
            </span>
            This will help us understand your learning level.
          </div>
          <div className={styles["button-wrapper"]}>
          <Button
          label={preAssessment===1 ? 'Start Learning' :"Start Pre-Course Assessment"}
          // disabled={!isVideoCompleted}
          disabled={isPending}
          className={styles.button}
          onClick={handleClick}
         />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EnrollmentSuccessfulComponent;
